var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.68548 0 0 2.70968 0 6C0 9.31452 2.68548 12 6 12C9.29032 12 12 9.31452 12 6C12 2.70968 9.29032 0 6 0ZM6 2.66129C6.55645 2.66129 7.01613 3.12097 7.01613 3.67742C7.01613 4.25806 6.55645 4.69355 6 4.69355C5.41935 4.69355 4.98387 4.25806 4.98387 3.67742C4.98387 3.12097 5.41935 2.66129 6 2.66129ZM7.35484 8.80645C7.35484 8.97581 7.20968 9.09677 7.06452 9.09677H4.93548C4.76613 9.09677 4.64516 8.97581 4.64516 8.80645V8.22581C4.64516 8.08064 4.76613 7.93548 4.93548 7.93548H5.22581V6.3871H4.93548C4.76613 6.3871 4.64516 6.26613 4.64516 6.09677V5.51613C4.64516 5.37097 4.76613 5.22581 4.93548 5.22581H6.48387C6.62903 5.22581 6.77419 5.37097 6.77419 5.51613V7.93548H7.06452C7.20968 7.93548 7.35484 8.08064 7.35484 8.22581V8.80645Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.455c29dd96df3fb4cc4b95e5a01f5c93.svg";
export { ForwardRef as ReactComponent };